import { Layout } from '@/utils/routerHelper'

// 会员管理
export default {
  path: '/member',
  redirect: '/member/direct-selling-member-list',
  component: Layout,
  name: 'Member',
  meta: {
    title: '会员管理',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'direct-selling-member-list',
      component: () => import('@/views/Member/DirectSelling/MemberList/Index.vue'),
      name: 'DirectSellingMemberList',
      meta: {
        title: '直销区会员管理'
      },
      children: [
        {
          path: 'edit-member',
          component: () => import('@/views/Member/DirectSelling/EditMember/Index.vue'),
          name: 'DirectSellingEditMember',
          meta: {
            title: '编辑会员',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Member/DirectSelling/MemberDetail/Index.vue'),
          name: 'DirectSellingMemberDetail',
          meta: {
            title: '直销会员详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        },
        {
          path: 'batch-edit-address',
          component: () => import('@/views/Member/DirectSelling/BatchEditAddress/Index.vue'),
          name: 'DirectSellingBatchEditAddress',
          meta: {
            title: '地址批量修改',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        },
        {
          path: 'import',
          component: () => import('@/views/Member/DirectSelling/ImportMember/Index.vue'),
          name: 'DirectSellingImportMember',
          meta: {
            title: '会员导入',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        },
        {
          path: 'import-record',
          component: () =>
            import('@/views/Member/DirectSelling/ImportMember/ImportMemberRecord/Index.vue'),
          name: 'DirectSellingImportMemberRecord',
          meta: {
            title: '查看导入会员',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        },
        {
          path: 'import-family-member-record',
          component: () =>
            import('@/views/Member/DirectSelling/ImportMember/ImportFamilyMembersRecord/Index.vue'),
          name: 'DirectSellingImportFamilyMembersRecord',
          meta: {
            title: '查看家庭成员',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-member-list'
          }
        }
      ]
    },
    {
      path: 'direct-selling-white-list',
      component: () => import('@/views/Member/DirectSelling/WhiteList/Index.vue'),
      name: 'DirectSellingWhiteList',
      meta: {
        title: '直销区开卡白名单'
      }
    },
    {
      path: 'direct-selling-business-audit',
      component: () => import('@/views/Member/DirectSelling/BusinessAudit/Index.vue'),
      name: 'DirectSellingBusinessAudit',
      meta: {
        title: '直销区业务审核'
      },
      children: [
        {
          path: 'set-violation-action',
          component: () =>
            import(
              '@/views/Member/DirectSelling/BusinessAudit/Violation/SetViolationAction/Index.vue'
            ),
          name: 'SetViolationAction',
          meta: {
            title: '违规行为设置',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        },
        {
          path: 'set-punishment-level',
          component: () =>
            import(
              '@/views/Member/DirectSelling/BusinessAudit/Violation/SetPunishmentLevel/Index.vue'
            ),
          name: 'SetPunishmentLevel',
          meta: {
            title: '处分等级设置',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        },
        {
          path: 'set-violation-type',
          component: () =>
            import(
              '@/views/Member/DirectSelling/BusinessAudit/Violation/SetViolationType/Index.vue'
            ),
          name: 'SetViolationType',
          meta: {
            title: '违规类型设置',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        },
        {
          path: 'edit-violation',
          component: () =>
            import('@/views/Member/DirectSelling/BusinessAudit/Violation/EditViolation/Index.vue'),
          name: 'EditViolation',
          meta: {
            title: '新建违规处理',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        },
        {
          path: 'apply-rename',
          component: () =>
            import('@/views/Member/DirectSelling/BusinessAudit/Rename/ApplyRename/Index.vue'),
          name: 'ApplyRename',
          meta: {
            title: '更名申请',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        },
        {
          path: 'reset-password-detail',
          component: () =>
            import('@/views/Member/DirectSelling/BusinessAudit/ResetPassword/Detail/Index.vue'),
          name: 'RestPasswordDetail',
          meta: {
            title: '重置密码详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/direct-selling-business-audit'
          }
        }
      ]
    },
    {
      path: 'public/member-list',
      component: () => import('@/views/Member/Public/MemberList/Index.vue'),
      name: 'PublicMemberList',
      meta: {
        title: '公共区顾客管理'
      },
      children: [
        {
          path: 'edit-member',
          component: () => import('@/views/Member/Public/EditMember/Index.vue'),
          name: 'PublicEditMember',
          meta: {
            title: '编辑顾客',
            hidden: true,
            canTo: true,
            activeMenu: '/member/public/member-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Member/Public/MemberDetail/Index.vue'),
          name: 'PublicMemberDetail',
          meta: {
            title: '公共顾客详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/public/member-list'
          }
        }
      ]
    },
    {
      path: 'receive-ginseng/member-list',
      component: () => import('@/views/Member/ReceiveGinseng/MemberList/Index.vue'),
      name: 'ReceiveGinsengMemberList',
      meta: {
        title: '领参区顾客管理'
      },
      children: [
        {
          path: 'edit-member',
          component: () => import('@/views/Member/ReceiveGinseng/EditMember/Index.vue'),
          name: 'ReceiveGinsengEditMember',
          meta: {
            title: '编辑顾客',
            hidden: true,
            canTo: true,
            activeMenu: '/member/receive-ginseng/member-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Member/ReceiveGinseng/MemberDetail/Index.vue'),
          name: 'ReceiveGinsengMemberDetail',
          meta: {
            title: '领参顾客详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/receive-ginseng/member-list'
          }
        }
      ]
    },
    {
      path: 'tag',
      component: () => import('@/views/Member/Tag/Index.vue'),
      name: 'MemberTag',
      meta: {
        title: '标签管理'
      },
      children: [
        {
          path: 'product-association',
          component: () => import('@/views/Member/Tag/ProductAssociation/Index.vue'),
          name: 'ProductAssociation',
          meta: {
            title: '产品关联详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/tag'
          }
        },
        {
          path: 'user-association',
          component: () => import('@/views/Member/Tag/UserAssociation/Index.vue'),
          name: 'UserAssociation',
          meta: {
            title: '用户关联详情',
            hidden: true,
            canTo: true,
            activeMenu: '/member/tag'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
